<template>
    <div id="app">
        <div class="lazy-box">
            <Header />
            <router-view />
            <Footer />
            <cookieTip />
        </div>
    </div>
</template>

<script>
import Header from '@/components/headers.vue'
import Footer from '@/components/footers.vue'
import cookieTip from '@/components/cookieTip.vue'
import Cookies from 'js-cookie'
export default {
    components: {
        Header,
        Footer,
        cookieTip,
    },
    created() {
        const query = this.$route.query
        if (query.source) {
            this.$store.state.receptionSave.orderSourceId = query.source
            // sessionStorage.setItem('orderSourceId', query.source)
            Cookies.set('orderSourceId', query.source)
        }
    },
}
</script>

<style>
.custom_popover{
    background-color: #ffffff !important;
    padding: 12px !important;
    line-height: 1.57 !important;
    border-radius: 8px !important;
    font-size: 12px !important;
    color: rgba(0, 0, 0, 0.88) !important;
}
</style>
